module.exports = __webpack_public_path__ + "fonts/BridgestoneType-Regular.1e6a4434.ttf";